import { Breakpoints, styled } from '@vw-marketing/us-components';

export const StyledTabsWrapper = styled.div`
  :nth-child(2) > div:first-child {
    padding: 0 ${({ theme }) => theme.size.grid002};
    justify-content: center;

    @media (min-width: ${Breakpoints.b960}px) {
      justify-content: start;
      padding: 0 ${({ theme }) => theme.size.grid002};
    }

    @media (min-width: ${Breakpoints.b1280}px) {
      padding: 0 ${({ theme }) => theme.size.grid001};
    }

    div:first-child {
      width: auto !important;
    }
  }
`;
